<template>
  <div class="app-notFound">
    <img :src="pic">
    <a @click="goHome">回到首页</a>
  </div>
</template>

<script>
import pic from '@/assets/images/404.png'
export default {
  name: 'notFound',
  data () {
    return {
      pic
    }
  },
  methods: {
    goHome () {
      this.$router.push('/overview/index')
    }
  }
}
</script>

<style lang="scss" scoped>
  .app-notFound {
    width: 100%;
    height: 100%;
    text-align: center;
    img {
      margin-top: 1.5rem;
    }
    a {
      display: block;
      width: .8rem;
      margin: .2rem auto;
      padding: .1rem .2rem;
      color: #1989fa;
      border: 1px solid #1989fa;
      border-radius: 5px;
      cursor: pointer;
    }
  }
</style>
